var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 0,
    clipRule: "evenodd",
    d: "M9.333 22.5h-2v-.003c-1.427-.01-2.264-.064-2.952-.335-1.144-.45-2.052-1.314-2.526-2.4-.355-.816-.355-1.85-.355-3.917v-4.103c0-1.194 0-1.79.135-2.346.18-.74.536-1.432 1.04-2.022.379-.442.874-.809 1.865-1.542l3.162-2.338C9.067 2.484 9.75 1.98 10.486 1.74a4.896 4.896 0 0 1 3.028 0c.737.24 1.419.745 2.784 1.754l3.162 2.338c.99.733 1.486 1.1 1.865 1.542l-1.52 1.3c-.196-.229-.467-.444-1.534-1.234l-3.163-2.338c-1.48-1.095-1.86-1.345-2.214-1.46a2.896 2.896 0 0 0-1.788 0c-.354.115-.733.365-2.214 1.46l-.04.029-3.123 2.31c-1.067.789-1.338 1.004-1.533 1.232a2.896 2.896 0 0 0-.618 1.196c-.065.268-.078.581-.078 1.873v4.103c0 1.062.001 1.754.04 2.284.036.51.1.72.149.833a2.56 2.56 0 0 0 1.425 1.34c.289.113.753.184 2.234.195l.344.003h8.616l.344-.003c1.48-.01 1.945-.082 2.234-.196a2.559 2.559 0 0 0 1.425-1.339c.05-.113.113-.322.15-.833.038-.53.039-1.222.039-2.284v-4.103c0-1.292-.013-1.605-.078-1.873a2.897 2.897 0 0 0-.618-1.196l1.52-1.299c.505.59.86 1.282 1.04 2.022.136.556.136 1.152.136 2.346v4.103c0 2.067 0 3.1-.355 3.916-.474 1.087-1.382 1.951-2.526 2.401-.688.271-1.524.325-2.952.335v.003H9.333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    fill: "none",
    d: "M8 12.5h8v9H8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.910a9dfc8b7727b3e2145603a9d830c7.svg";
export { ForwardRef as ReactComponent };